import { useMemo } from 'react';
import { Axis } from '@visx/axis';
import AnimatedTicks from "./AnimatedTicks.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedAxis(_ref) {
  let {
    animationTrajectory,
    tickComponent,
    ...axisProps
  } = _ref;
  // wrap the ticksComponent so we can pass animationTrajectory
  const ticksComponent = useMemo(() =>
  // eslint-disable-next-line react/no-unstable-nested-components
  function TicksComponent(ticks) {
    return /*#__PURE__*/_jsx(AnimatedTicks, {
      ...ticks,
      tickComponent: tickComponent,
      animationTrajectory: animationTrajectory
    });
  }, [animationTrajectory, tickComponent]);
  return /*#__PURE__*/_jsx(Axis, {
    ...axisProps,
    ticksComponent: ticksComponent
  });
}